import { graphql } from "./__generated__/gql";

export const UPCOMING_EVENTS_QUERY = graphql(`
  query UpcomingEvents($now: Datetime!) {
    eventCollection(
      filter: {
        ends_at: { gt: $now }
        or: [{ status: { eq: "draft" } }, { status: { eq: "published" } }]
      }
      orderBy: [{ starts_at: AscNullsLast }]
    ) {
      edges {
        node {
          id
          title
          description
          slug
          status
          visibility
          starts_at
          ends_at
          flyer_url
          created_by_user_id
          location_name
          location_street
          location_city
          location_state
          location_postal_code
          location_geo
          location_place_id
          location_neighborhood
          event_ticket_kindCollection {
            edges {
              node {
                id
                currency
                description
                name
                price_cents
                price_service_fee
                quantity_total
                quantity_sold
                status
              }
            }
          }
          event_memberCollection {
            edges {
              node {
                user_id
                role
                rsvp_status
              }
            }
          }
        }
      }
    }
  }
`);

export const PAST_USER_EVENTS_QUERY = graphql(`
  query PastUserEvents($now: Datetime!) {
    eventCollection(
      filter: { ends_at: { lt: $now }, status: { eq: "published" } }
      orderBy: [{ starts_at: DescNullsLast }]
    ) {
      edges {
        node {
          id
          title
          description
          slug
          status
          visibility
          starts_at
          ends_at
          flyer_url
          created_by_user_id
          location_name
          location_street
          location_city
          location_state
          location_postal_code
          location_geo
          location_place_id
          location_neighborhood
          event_ticket_kindCollection {
            edges {
              node {
                id
                currency
                description
                name
                price_cents
                price_service_fee
                quantity_total
                quantity_sold
                status
              }
            }
          }
          event_memberCollection {
            edges {
              node {
                user_id
                role
                rsvp_status
              }
            }
          }
        }
      }
    }
  }
`);
